import styled from 'styled-components'
import Threshold from 'constants/threshold'
import Colors from 'constants/colors'

export const AuthorContainer = styled.div<{
  length?: number
}>`
  display: flex;
  flex-direction: column;
  margin-left: 17px;
  justify-content: space-between;

  @media (min-width: ${Threshold.phone}) {
    max-width: ${props => (props.length <= 3 ? '479px' : '209px')};
  }

  & .author-name {
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    text-align: start;

    @media (min-width: ${Threshold.phone}) {
      font-size: 16px;
      line-height: normal;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  & .author-description {
    font-size: 12px;
    line-height: 20px;

    @media (min-width: ${Threshold.phone}) {
      white-space: ${props => (props.length <= 3 ? 'wrap' : 'nowrap')};
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  @media (min-width: ${Threshold.tablet}) {
    margin-left: 21px;
  }
`

export const IframeContainer = styled.div`
  width: 100%;
  position: relative;
  height: 0;
  max-width: 330px;
  height: 200px;

  @media (min-width: ${Threshold.phone}) {
    height: 270px;
    max-width: 500px;
  }

  @media (min-width: ${Threshold.tablet}) {
    margin-right: 40px;
  }
`

export const VideoContainer = styled.div<{
  length?: number
}>`
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  width: 100%;
  font-family: 'Geometria';

  .overlay {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    cursor: pointer;
  }

  &:not(:last-child) {
    margin-bottom: 40px;
  }
  & .video-title {
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    color: ${Colors.blue};
    margin-bottom: 10px;
  }

  & .video-name {
    margin-bottom: 20px;
    font-weight: bold;
    font-size: 20px;
    line-height: 30px;
    text-transform: none;
    text-align: start;
    @media (min-width: ${Threshold.phone}) {
      margin-bottom: 17px;
    }
  }

  & .video-description {
    display: inline-block;
    margin-bottom: 20px;
    font-weight: 500;
    font-size: 14px;
  }

  & .width-limiter {
    max-width: 330px;
    width: 100%;
    display: flex;
    flex-direction: column;

    @media (min-width: ${Threshold.phone}) {
      max-width: 500px;
    }
  }

  .description__container {
    max-width: 520px;
    margin: 20px 0 0;
    @media (min-width: ${Threshold.phone}) {
      width: 520px;
      margin: 0;
    }
  }

  & .author__list {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    @media (min-width: ${Threshold.phone}) {
      max-height: 161px;
      flex-wrap: wrap;
    }
  }

  & .author__item {
    display: flex;
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    @media (min-width: ${Threshold.phone}) {
      max-width: ${props => (props.length <= 3 ? '520px' : '250px')};
      &:nth-child(3n) {
        margin-bottom: 0;
      }
    }
  }

  @media (min-width: ${Threshold.tablet}) {
    & .width-limiter {
      flex-direction: row;
      max-width: 1060px;
    }

    &:not(:last-child) {
      margin-bottom: 30px;
    }

    & .video-name {
      margin: 0 0 20px;
      text-align: start;
    }

    & .video-description {
      margin-bottom: 37px;
    }
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  flex-direction: column;
  gap: 10px;

  @media (min-width: ${Threshold.phone}) {
    flex-direction: row;
    gap: 0;
  }
`
export const ButtonContainer = styled.div`
  min-width: 235px;
  width: 100%;
  @media (min-width: ${Threshold.phone}) {
    width: 235px;
  }
`
export const VideoColumn = styled.div`
  width: 100%;
  max-width: 500px;

  @media (min-width: ${Threshold.phone}) {
    margin-right: 40px;
    width: 500px;
  }
`
